"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _InteractionWithValidatedAttachments = _interopRequireDefault(require("customer-data-communicator/components/wrappers/InteractionWithValidatedAttachments"));

var _InteractionWithValidatedEmailAttachmentsComponentConfig = _interopRequireDefault(require("customer-data-communicator/components/interactions/email/config/InteractionWithValidatedEmailAttachmentsComponentConfig"));

var _loggers = require("customer-data-tracking/loggers");

var _default = (0, _InteractionWithValidatedAttachments.default)(_InteractionWithValidatedEmailAttachmentsComponentConfig.default.merge({
  onOpenPopover: function onOpenPopover() {
    _loggers.CommunicatorLogger.log('communicatorInteraction', {
      action: 'click to attach file',
      activity: 'email',
      channel: 'email',
      source: 'communicator'
    });
  }
}));

exports.default = _default;
module.exports = exports.default;